// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   Switch,
// } from "@mui/material";

// import { BaseUrl } from "../../../../../api/AxiosApi";
// import { PrAnalysisTab2Api, TotalPowerApi } from "../../../../../api/Api";
// import TopHeader from "../../../../../components/general/TopHeader";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// // ✅ Get today date for input (YYYY-MM-DD)
// const getTodayDate = () => {
//   const today = new Date();
//   return today.toISOString().split("T")[0];
// };

// // ✅ 5AM fallback
// function getToday5AMToNow() {
//   const now = new Date();
//   const start = new Date();
//   start.setHours(5, 0, 0, 0);

//   if (now < start) {
//     start.setDate(start.getDate() - 1);
//   }

//   const format = (date) => {
//     const pad = (n) => n.toString().padStart(2, "0");
//     return `${pad(date.getDate())}-${date.toLocaleString("en-GB", {
//       month: "long",
//     })}-${date.getFullYear()} ${pad(date.getHours())}:${pad(
//       date.getMinutes()
//     )}:${pad(date.getSeconds())}`;
//   };

//   return {
//     from: format(start),
//     to: format(now),
//   };
// }

// // ✅ Date Formatter
// function formatDateTime(dateStr, isStart = true) {
//   const date = new Date(dateStr);

//   if (isStart) {
//     date.setHours(0, 0, 0, 0);
//   } else {
//     date.setHours(23, 59, 59, 0);
//   }

//   const pad = (n) => n.toString().padStart(2, "0");

//   return `${pad(date.getDate())}-${date.toLocaleString("en-GB", {
//     month: "long",
//   })}-${date.getFullYear()} ${pad(date.getHours())}:${pad(
//     date.getMinutes()
//   )}:${pad(date.getSeconds())}`;
// }

// function LoadPatternTab4() {
//   const chartRef = useRef();

//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [isAllSelected, setIsAllSelected] = useState(false);
//   const [viewMode, setViewMode] = useState("all");

//   // ✅ Default current date set
//   const [fromDate, setFromDate] = useState(getTodayDate());
//   const [toDate, setToDate] = useState(getTodayDate());

//   const metric = "KW";

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LCODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}Open/Get_Open_feed`,
//           {
//             params: {
//               USER_ID: credentials.LOGIN_ID,
//               PLANT_code: credentials.LCODE,
//               pass_key: credentials.PASS_KEY,
//               Stype: "S",
//             },
//           }
//         );

//         const feederList = res.data?.data || [];
//         setInverters(feederList);

//         if (feederList.length > 0) {
//           setSelectedKeys([feederList[0].ID]);
//         }

//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (e) => {
//     const checked = e.target.checked;
//     setIsAllSelected(checked);

//     if (checked) {
//       setSelectedKeys(inverters.map((inv) => inv.ID));
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Toggle checkbox
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   useEffect(() => {
//     setIsAllSelected(
//       inverters.length > 0 && selectedKeys.length === inverters.length
//     );
//   }, [selectedKeys, inverters]);

//   // 🔥 MAIN FUNCTION
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) {
//       setChartData(null);
//       return;
//     }

//     setLoading(true);

//     try {
//       let datasets = [];
//       let allLabelsSet = new Set();

//       let from, to;

//       if (fromDate && toDate) {
//         from = formatDateTime(fromDate, true);
//         to = formatDateTime(toDate, false);
//       } else {
//         const range = getToday5AMToNow();
//         from = range.from;
//         to = range.to;
//       }
//       const plantRes = await TotalPowerApi({
//         LOGIN_ID: credentials.LOGIN_ID,
//         LOC_CODE: credentials.LCODE,
//         PASS_KEY: credentials.PASS_KEY,
//         WEB_KEY: credentials.WEB_KEY,
//         DT1: from,
//         DT2: to,
//       });

//       const plantData = plantRes?.data || [];
//       plantData.forEach((d) => allLabelsSet.add(d.datet));

//       // console.log("plantRes", plantRes);
//       // console.log("plantData", plantData);

//       let inverterResponses = [];

//       for (const inv of inverters) {
//         if (!selectedKeys.includes(inv.ID)) continue;

//         const res = await axios.post(
//           `${BaseUrl}CMN_08InvLog/post_INV_LOG`,
//           new URLSearchParams({
//             LOGIN_ID: credentials.LOGIN_ID,
//             PASS_KEY: credentials.PASS_KEY,
//             WEB_KEY: credentials.WEB_KEY,
//             MTRNO: inv.MTR,
//             DT1: from,
//             DT2: to,
//           })
//         );

//         const apiData = res.data?.data || [];
//         apiData.forEach((d) => allLabelsSet.add(d.DT));

//         inverterResponses.push({
//           name: inv.NAME,
//           data: apiData,
//         });
//       }

//       const allLabels = Array.from(allLabelsSet).sort(
//         (a, b) => new Date(a) - new Date(b)
//       );

//       if (viewMode === "total" || viewMode === "all") {

//         const incomerMap = {};
//         const outgoingMap = {};
//         const spareMap = {};

//         plantData.forEach((d) => {
//           incomerMap[d.datet] = parseFloat(d.INCOMER_KW ?? 0);
//           outgoingMap[d.datet] = parseFloat(d.OUTGOING_KW ?? 0);
//           spareMap[d.datet] = parseFloat(d.SPARE_KW ?? 0);
//         });

//         // INCOMER KW
//         // datasets.push({
//         //   type: "line",
//         //   label: "INCOMER (KW)",
//         //   data: allLabels.map(x => incomerMap[x] ?? null),

//         //   borderColor: "#ff0000",
//         //   backgroundColor: "#ff0000",

//         //   borderWidth: 2,

//         //   pointRadius: 0,

//         //   pointHoverRadius: 5,

//         //   tension: 0.35,

//         //   spanGaps: true,

//         //   fill: false,

//         //   yAxisID: "y1",
//         // });

//         // OUTGOING KW
//         // datasets.push({
//         //   type: "line",
//         //   label: "OUTGOING (KW)",
//         //   data: allLabels.map((label) => outgoingMap[label] ?? null),
//         //   borderColor: "#008000",
//         //   backgroundColor: "#008000",
//         //   borderWidth: 2,

//         //   pointRadius: 0,

//         //   pointHoverRadius: 5,

//         //   tension: 0.35,

//         //   spanGaps: true,

//         //   fill: false,

//         //   yAxisID: "y1",
//         // });

//         // SPARE KW
//         datasets.push({
//           type: "line",
//           label: "SPARE TOTAL (KW)",
//           data: allLabels.map((label) => spareMap[label] ?? null),
//           borderColor: "#0000ff",
//           backgroundColor: "#0000ff",
//           borderWidth: 2,

//           pointRadius: 0,

//           pointHoverRadius: 5,

//           tension: 0.35,

//           spanGaps: true,

//           fill: false,

//           yAxisID: "y1",
//         });

//       }

//       inverterResponses.forEach((inv) => {
//         const dataMap = {};
//         inv.data.forEach((d) => {
//           dataMap[d.DT] = parseFloat(d[metric] ?? 0);
//         });

//         datasets.push({
//           type: "line",
//           label: inv.name,
//           data: allLabels.map((l) => dataMap[l] ?? null),
//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),

//           borderWidth: 2,

//           pointRadius: 0,

//           pointHoverRadius: 5,

//           tension: 0.35,

//           spanGaps: true,

//           fill: false,

//           yAxisID: "y1",
//         });
//       });

//       setChartData({ labels: allLabels, datasets });
//     } catch (err) {
//       console.log(err);
//       setChartData(null);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     if (selectedKeys.length > 0) {
//       fetchChartData();
//     }
//   }, [selectedKeys, viewMode]);

//   return (
//     <>
//       {/* <TopHeader /> */}
//       <div style={{ padding: "10px" }}>
//         <Typography variant="h5" fontWeight="bold">
//          Spare Load Pattern
//         </Typography>

//         <Paper sx={{ p: 2, mb: 2 }}>
//           <FormControlLabel
//             control={
//               <Switch
//                 checked={isAllSelected}
//                 onChange={handleSelectAll}
//               />
//             }
//             label="Select All Meters"
//           />

//           <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//             {inverters.map((inv) => (
//               <FormControlLabel
//                 key={inv.ID}
//                 control={
//                   <Checkbox
//                     size="small"
//                     checked={selectedKeys.includes(inv.ID)}
//                     onChange={() => handleToggle(inv.ID)}
//                   />
//                 }
//                 label={inv.NAME}
//               />
//             ))}
//           </Box>

//           {/* ✅ Date Controls */}
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
//             <Typography>From:</Typography>
//             <input
//               type="date"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//             />

//             <Typography>To:</Typography>
//             <input
//               type="date"
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)}
//             />

//             <TbRefresh
//               style={{ fontSize: "18px", cursor: "pointer" }}
//               onClick={fetchChartData}
//             />
//           </Box>
//         </Paper>

//         <Paper sx={{ p: 2, height: 350 }}>
//           {loading ? (
//             <Typography align="center">Loading...</Typography>
//           ) : chartData ? (
//             <Line
//               ref={chartRef}
//               data={chartData}
//               options={{
//                 responsive: true,
//                 maintainAspectRatio: false,

//                 interaction: {
//                   mode: "index",
//                   intersect: false,
//                 },

//                 plugins: {
//                   legend: {
//                     display: true,
//                     position: "top",
//                   },

//                   tooltip: {
//                     enabled: true,
//                     mode: "index",
//                     intersect: false,

//                     callbacks: {
//                       title: function (context) {
//                         return context[0].label;
//                       },

//                       label: function (context) {
//                         return `${context.dataset.label}: ${context.parsed.y} KW`;
//                       },
//                     },
//                   },
//                 },

//                 hover: {
//                   mode: "index",
//                   intersect: false,
//                 },

//                 elements: {
//                   point: {
//                     radius: 0,
//                     hoverRadius: 6,
//                     hitRadius: 15,
//                   },
//                   line: {
//                     tension: 0.35,
//                   },
//                 },

//                 scales: {
//                   y: {
//                     position: "left",
//                     beginAtZero: true,
//                   },

//                   y1: {
//                     position: "right",
//                     beginAtZero: true,
//                     grid: {
//                       drawOnChartArea: false,
//                     },
//                   },
//                 },
//               }}
//             />
//           ) : (
//             <Typography align="center">No data</Typography>
//           )}
//         </Paper>
//       </div>
//     </>
//   );
// }

// export default LoadPatternTab4;

// 2.

import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { TbRefresh } from "react-icons/tb";
import {
  Paper,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  Switch,
} from "@mui/material";

import { BaseUrl } from "../../../../../api/AxiosApi";
import { PrAnalysisTab2Api, TotalPowerApi } from "../../../../../api/Api";
import TopHeader from "../../../../../components/general/TopHeader";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// ✅ Get today date for input (YYYY-MM-DD)
const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

// ✅ 5AM fallback
function getToday5AMToNow() {
  const now = new Date();
  const start = new Date();
  start.setHours(5, 0, 0, 0);

  if (now < start) {
    start.setDate(start.getDate() - 1);
  }

  const format = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");
    return `${pad(date.getDate())}-${date.toLocaleString("en-GB", {
      month: "long",
    })}-${date.getFullYear()} ${pad(date.getHours())}:${pad(
      date.getMinutes()
    )}:${pad(date.getSeconds())}`;
  };

  return {
    from: format(start),
    to: format(now),
  };
}

// ✅ Date Formatter
function formatDateTime(dateStr, isStart = true) {
  const date = new Date(dateStr);

  if (isStart) {
    date.setHours(0, 0, 0, 0);
  } else {
    date.setHours(23, 59, 59, 0);
  }

  const pad = (n) => n.toString().padStart(2, "0");

  return `${pad(date.getDate())}-${date.toLocaleString("en-GB", {
    month: "long",
  })}-${date.getFullYear()} ${pad(date.getHours())}:${pad(
    date.getMinutes()
  )}:${pad(date.getSeconds())}`;
}


function LoadPatternTab4() {
  const chartRef = useRef();

  const [inverters, setInverters] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [viewMode, setViewMode] = useState("all");

  // ✅ Default current date set
  const [fromDate, setFromDate] = useState(getTodayDate());
  const [toDate, setToDate] = useState(getTodayDate());

  const metric = "KW";

  const credentials = {
    LOGIN_ID: localStorage.getItem("LoginID"),
    LCODE: localStorage.getItem("LCODE"),
    PASS_KEY: "XYZ",
    WEB_KEY: "WEBXYZ321",
  };

  // 🔹 Fetch inverter list
  useEffect(() => {
    async function fetchInverters() {
      try {
        const res = await axios.get(
          `${BaseUrl}Open/Get_Open_feed`,
          {
            params: {
              USER_ID: credentials.LOGIN_ID,
              PLANT_code: credentials.LCODE,
              pass_key: credentials.PASS_KEY,
              Stype: "S",
            },
          }
        );

        const feederList = res.data?.data || [];
        setInverters(feederList);

        if (feederList.length > 0) {
          setSelectedKeys([feederList[0].ID]);
        }

      } catch (err) {
        console.error(err);
      }
    }

    fetchInverters();
  }, []);

  // 🔹 Select All
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setIsAllSelected(checked);

    if (checked) {
      setSelectedKeys(inverters.map((inv) => inv.ID));
    } else {
      setSelectedKeys([]);
    }
  };

  // 🔹 Toggle checkbox
  const handleToggle = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key)
        ? prev.filter((k) => k !== key)
        : [...prev, key]
    );
  };

  useEffect(() => {
    setIsAllSelected(
      inverters.length > 0 && selectedKeys.length === inverters.length
    );
  }, [selectedKeys, inverters]);

  // 🔥 MAIN FUNCTION
  const fetchChartData = async () => {
    if (selectedKeys.length === 0) {
      setChartData(null);
      return;
    }

    setLoading(true);

    try {
      let datasets = [];
      let allLabelsSet = new Set();

      let from, to;

      if (fromDate && toDate) {
        from = formatDateTime(fromDate, true);
        to = formatDateTime(toDate, false);
      } else {
        const range = getToday5AMToNow();
        from = range.from;
        to = range.to;
      }
      const plantRes = await TotalPowerApi({
        LOGIN_ID: credentials.LOGIN_ID,
        LOC_CODE: credentials.LCODE,
        PASS_KEY: credentials.PASS_KEY,
        WEB_KEY: credentials.WEB_KEY,
        DT1: from,
        DT2: to,
      });

      const plantData = plantRes?.data || [];
      plantData.forEach((d) => allLabelsSet.add(d.datet));

      let inverterResponses = [];

      for (const inv of inverters) {
        if (!selectedKeys.includes(inv.ID)) continue;

        const res = await axios.post(
          `${BaseUrl}CMN_08InvLog/post_INV_LOG`,
          new URLSearchParams({
            LOGIN_ID: credentials.LOGIN_ID,
            PASS_KEY: credentials.PASS_KEY,
            WEB_KEY: credentials.WEB_KEY,
            MTRNO: inv.MTR,
            DT1: from,
            DT2: to,
          })
        );

        const apiData = res.data?.data || [];
        apiData.forEach((d) => allLabelsSet.add(d.DT));

        inverterResponses.push({
          name: inv.NAME,
          data: apiData,
        });
      }

      const allLabels = Array.from(allLabelsSet).sort(
        (a, b) => new Date(a) - new Date(b)
      );

      if (viewMode === "total" || viewMode === "all") {

        const incomerMap = {};
        const outgoingMap = {};
        const spareMap = {};

        plantData.forEach((d) => {
          incomerMap[d.datet] = parseFloat(d.INCOMER_KW ?? 0);
          outgoingMap[d.datet] = parseFloat(d.OUTGOING_KW ?? 0);
          spareMap[d.datet] = parseFloat(d.SPARE_KW ?? 0);
        });

        // INCOMER KW
        datasets.push({
          type: "line",
          label: "INCOMER TOTAL (KW)",
          data: allLabels.map(x => incomerMap[x] ?? null),
          borderColor: "#ff0000",
          backgroundColor: "#ff0000",
          borderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 5,
          tension: 0.35,
          spanGaps: true,
          fill: false,
          yAxisID: "y", // 🔹 Single axis 'y' पर सेट किया
        });

        // OUTGOING KW
        datasets.push({
          type: "line",
          label: "OUTGOING TOTAL (KW)",
          data: allLabels.map((label) => outgoingMap[label] ?? null),
          borderColor: "#008000",
          backgroundColor: "#008000",
          borderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 5,
          tension: 0.35,
          spanGaps: true,
          fill: false,
          yAxisID: "y", // 🔹 Single axis 'y' पर सेट किया
        });

        // SPARE KW
        datasets.push({
          type: "line",
          label: "SPARE TOTAL (KW)",
          data: allLabels.map((label) => spareMap[label] ?? null),
          borderColor: "#0000ff",
          backgroundColor: "#0000ff",
          borderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 5,
          tension: 0.35,
          spanGaps: true,
          fill: false,
          yAxisID: "y", // 🔹 Single axis 'y' पर सेट किया
        });
      }

      inverterResponses.forEach((inv) => {
        const dataMap = {};
        inv.data.forEach((d) => {
          dataMap[d.DT] = parseFloat(d[metric] ?? 0);
        });

        datasets.push({
          type: "line",
          label: inv.name,
          data: allLabels.map((l) => dataMap[l] ?? null),
          borderColor: "#" + Math.floor(Math.random() * 16777215).toString(16),
          borderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 5,
          tension: 0.35,
          spanGaps: true,
          fill: false,
          yAxisID: "y", // 🔹 Single axis 'y' पर सेट किया
        });
      });

      setChartData({ labels: allLabels, datasets });
    } catch (err) {
      console.log(err);
      setChartData(null);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (selectedKeys.length > 0) {
      fetchChartData();
    }
  }, [selectedKeys, viewMode]);

  return (
    <>
      <div style={{ padding: "10px" }}>
        <Typography variant="h5" fontWeight="bold">
           Load Pattern
        </Typography>

        <Paper sx={{ p: 2, mb: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={isAllSelected}
                onChange={handleSelectAll}
              />
            }
            label="Select All Meters"
          />

          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            {inverters.map((inv) => (
              <FormControlLabel
                key={inv.ID}
                control={
                  <Checkbox
                    size="small"
                    checked={selectedKeys.includes(inv.ID)}
                    onChange={() => handleToggle(inv.ID)}
                  />
                }
                label={inv.NAME}
              />
            ))}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
            <Typography>From:</Typography>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />

            <Typography>To:</Typography>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />

            <TbRefresh
              style={{ fontSize: "18px", cursor: "pointer" }}
              onClick={fetchChartData}
            />
          </Box>
        </Paper>

        <Paper sx={{ p: 2, height: 350 }}>
          {loading ? (
            <Typography align="center">Loading...</Typography>
          ) : chartData ? (
            <Line
              ref={chartRef}
              data={chartData}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                  mode: "index",
                  intersect: false,
                },
                plugins: {
                  legend: {
                    display: true,
                    position: "top",
                  },
                  tooltip: {
                    enabled: true,
                    mode: "index",
                    intersect: false,
                    callbacks: {
                      title: function (context) {
                        return context[0].label;
                      },
                      label: function (context) {
                        return `${context.dataset.label}: ${context.parsed.y} KW`;
                      },
                    },
                  },
                },
                hover: {
                  mode: "index",
                  intersect: false,
                },
                elements: {
                  point: {
                    radius: 0,
                    hoverRadius: 6,
                    hitRadius: 15,
                  },
                  line: {
                    tension: 0.35,
                  },
                },
                scales: {
                  y: {
                    position: "left",
                    beginAtZero: true,
                    title: {
                      display: true,
                      text: "", // Axis का टाइटल (वैकल्पिक)
                    },
                  },
                  // 🔹 'y1' एक्सिस को यहाँ से पूरी तरह हटा दिया गया है
                },
              }}
            />
          ) : (
            <Typography align="center">No data</Typography>
          )}
        </Paper>
      </div>
    </>
  );
}

export default LoadPatternTab4;